import { call, takeEvery, put } from "redux-saga/effects";
import * as type from "../../types";
import { viewSubtranctionApi } from "../../api/business/SubtractionApi";

function* handleViewSubtraction() {
  try {
    const response = yield call(viewSubtranctionApi);
    const subtraction = response.data?.subscriptionplan || [];
    yield put({ type: type.SUBTRANCTION_FETCH_SUCCESS, subtraction });
  } catch (error) {
    yield put({ type: type.SUBTRANCTION_FETCH_FAILURE, error: error.message });
  }
}

export function* watchViewSubTranctionSaga() {
  yield takeEvery(type.SUBTRANCTION_FETCH_REQUEST, handleViewSubtraction);
}
